import { render, staticRenderFns } from "./ExceptionOpeningHours.vue?vue&type=template&id=5191f3c0&scoped=true"
import script from "./ExceptionOpeningHours.vue?vue&type=script&lang=js"
export * from "./ExceptionOpeningHours.vue?vue&type=script&lang=js"
import style0 from "./ExceptionOpeningHours.vue?vue&type=style&index=0&id=5191f3c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5191f3c0",
  null
  
)

export default component.exports